import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, FileText, Zap, MapPin, Users } from 'lucide-react';
export function HeroSection() {
  return <section className="px-4 max-w-5xl mx-auto text-center mt-[-50px] mb-[-50px] space-y-[0px] pt-[10px] pb-[10px]" data-id="element-195">
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="inline-flex items-center gap-2 bg-[#22c55e]/10 text-[#16a34a] px-4 py-1.5 rounded-full font-bold border border-[#22c55e]/30 mt-[0px] mb-[0px] text-[14px] shadow-sm" data-id="element-196">
        <span data-id="element-197">🏃</span> TU MANUAL DIGITAL™
      </motion.div>

      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} className="md:text-7xl font-extrabold tracking-tight text-balance mt-[-5px] mb-[-5px] text-[28px] text-[#0f172a]" data-id="element-198">
        El sistema que convierte tu cuerpo y tu entrenamiento en una máquina de
        rendimiento
      </motion.h1>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="mb-8 space-y-[0px]" data-id="element-199"></motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={{
      duration: 0.7,
      delay: 0.25
    }} className="flex flex-col items-center justify-center my-6" data-id="element-200">
        <img src="https://cdn.magicpatterns.com/uploads/mTV6H7aVb48rgZVuvRDeyC/mockup_1-removebg-preview_(1).png" alt="Sistema Running Pro - Mockup del producto" className="w-[62.5%] max-w-[17.5rem] md:max-w-sm drop-shadow-[0_20px_40px_rgba(34,197,94,0.3)] pt-[0px] pb-[0px] mt-[0px] mb-[0px]" data-id="element-201" />
        <p className="md:text-2xl text-[#0f172a] font-bold pt-[5px] pb-[5px] text-[16px]" data-id="element-202">
          Para corredores de ruta y trail que quieren rendir más, lesionarse
          menos y nunca más quedarse parados por dolor o estancamiento.
        </p>
        <p className="text-[#475569] font-medium pt-[0px] pb-[0px] mt-[0px] mb-[0px] text-[12px]" data-id="element-203">
          Entrenamiento · Técnica · Nutrición · Fuerza · Todo listo para aplicar
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3 text-xs md:text-sm font-bold text-[#475569] mt-[0px] mb-[0px] items-stretch justify-center pt-[10px] pb-[10px]" data-id="element-204">
        <div className="flex items-center justify-center gap-1 bg-white px-3 py-1.5 rounded-md border border-[#e2e8f0] whitespace-nowrap shadow-sm" data-id="element-205">
          <FileText size={14} className="text-[#22c55e]" data-id="element-206" /> 100% PDF
        </div>
        <div className="flex items-center justify-center gap-1 bg-white px-3 py-1.5 rounded-md border border-[#e2e8f0] whitespace-nowrap font-bold shadow-sm" data-id="element-207">
          <Zap size={14} className="text-[#22c55e]" data-id="element-208" /> Acceso al instante
        </div>
        <div className="flex items-center justify-center gap-1 bg-white px-3 py-1.5 rounded-md border border-[#e2e8f0] whitespace-nowrap shadow-sm" data-id="element-209">
          <MapPin size={14} className="text-[#22c55e]" data-id="element-210" /> Ruta y Trail
        </div>
        <div className="flex items-center justify-center gap-1 bg-white px-3 py-1.5 rounded-md border border-[#e2e8f0] whitespace-nowrap shadow-sm" data-id="element-211">
          <Users size={14} className="text-[#22c55e]" data-id="element-212" /> Para todos los niveles
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="flex flex-col items-center" data-id="element-213">
        <a href="#pricing" className="group relative inline-flex px-8 py-5 text-xl font-black text-[#020617] bg-[#22c55e] rounded-xl overflow-hidden transition-all hover:scale-105 hover:bg-[#4ade80] shadow-[0_10px_40px_rgba(34,197,94,0.4)] animate-pulse-slow w-full max-w-md gap-[0px] items-center justify-center pt-[10px] pb-[10px] pl-[0px] pr-[0px] mt-[0px] mb-[0px]" data-id="element-214">
          <span className="relative z-10 flex gap-[10px] items-center justify-center text-[18px] pt-[4px] pb-[4px]" data-id="element-215">
            → QUIERO MI SISTEMA RUNNING PRO AHORA
          </span>
          <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-216" />
        </a>

        <div className="flex flex-wrap justify-center mt-6 text-sm text-[#475569] font-medium gap-[8px]" data-id="element-217">
          <span className="flex items-center gap-1.5" data-id="element-218">
            <Shield size={16} className="text-[#22c55e]" data-id="element-219" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-220">
            <Lock size={16} className="text-[#22c55e]" data-id="element-221" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-222">
            <CreditCard size={16} className="text-[#22c55e]" data-id="element-223" /> Mercado Pago
          </span>
        </div>
      </motion.div>
    </section>;
}